module.exports = __webpack_public_path__ + "img/qr.e709bd1b.png";